import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { migrateLocalStorage } from "@/lib/migrateLocalStorage";

// Sage → Aanar rebrand: copy any stale `sage_*` keys to their new `aanar_*`
// names once per browser. Runs BEFORE React mounts so consumers see the new
// key immediately without a reload.
migrateLocalStorage();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
